<template>
  <keep-alive>
    <v-container
      fluid
      style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
      class="d-flex flex-column"
    >
      <v-alert
        dismissible
        v-for="notification in notifications"
        :key="notification"
        style="margin-left: 100px; margin-right: 80px;"
        type="success"
      >
        {{ notification }}
      </v-alert>
      <v-alert
        dismissible
        v-for="notification in errorNotifications"
        :key="notification"
        style="margin-left: 100px; margin-right: 80px;"
        type="error"
      >
        {{ notification }}
      </v-alert>
      <div
        style="height: 100%; padding:0px; min-height: inherit; max-width: 1500px"
        class="flex-row d-flex"
      >
        <volunteer-left-section class="hidden-sm-and-down" v-if="profile.type == 'Admin' || profile.type == 'Agency' || profile.type == 'Volunteer'"/>
        <volunteer-agencies-section v-if="profile.type == 'Admin' || profile.type == 'Agency' || profile.type == 'Volunteer'"/>
        <volunteer-right-section class="hidden-md-and-down" v-if="profile.type == 'Admin' || profile.type == 'Agency' || profile.type == 'Volunteer'"/>
         <not-found v-else />
      </div>
      <v-snackbar v-model="snackbar">
        {{ errorMessage }}
      </v-snackbar>
    </v-container>
  </keep-alive>
</template>
<script>
import { mapActions, mapState } from "vuex";
import VolunteerLeftSection from "../VolunteerLeftSection.vue";
import VolunteerRightSection from "../VolunteerRightSection.vue";
import VolunteerAgenciesSection from "./VolunteerAgenciesSection.vue";
import NotFound from "../../NotFound.vue";
export default {
  components: {
    VolunteerLeftSection,
    VolunteerRightSection,
    VolunteerAgenciesSection,
    NotFound
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      verifyPhoneDialog: false,
      completeProfileDialog: false,
      causeDialog: false,
      interestsDialog: false,
      availabilitiesDialog: false,
      congratesDialog: false,
      notifications: [],
      errorNotifications: []
    };
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    }
  },
  computed: {
    ...mapState("auth", {
      profile: "profile"
    })
  }
};
</script>
<style scoped></style>
